import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import AppBanner from './AppBanner';
import { useLanguage } from '../contexts/LanguageContext';

const ThankYouPage = () => {
  const navigate = useNavigate();
  const { t, isRTL } = useLanguage();

  useEffect(() => {
    // Check if user is logged in
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (!session) {
        navigate('/login');
      }
    });
  }, [navigate]);

  const handleGoDashboard = () => {
    navigate('/');
  };

  // Real logout handler for AppBanner
  const handleLogout = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) {
      alert('Failed to log out: ' + error.message);
    } else {
      window.location.href = '/login';
    }
  };

  return (
    <>
      <AppBanner onLogout={handleLogout} />
      <div style={{ maxWidth: 520, margin: '60px auto', padding: 32, background: '#fff', borderRadius: 14, boxShadow: '0 4px 24px rgba(0,0,0,0.09)', textAlign: 'center' }} dir={isRTL ? 'rtl' : 'ltr'}>
        <h1 style={{ color: '#386641', marginBottom: 18 }}>{t('thankYouTitle')}</h1>
        <p style={{ fontSize: '1.15rem', marginBottom: 18 }}>
          {t('thankYouSuccessLine1')}<br />
          {t('thankYouSuccessLine2')}
        </p>
        <button
          className='btn btn-primary'
          style={{ fontSize: '1.1rem', padding: '12px 32px', borderRadius: 8, fontWeight: 600, background: 'linear-gradient(90deg, #a8e063 0%, #56ab2f 100%)', border: 'none', color: '#fff', boxShadow: '0 2px 8px rgba(56,102,65,0.10)' }}
          onClick={handleGoDashboard}
        >
          {t('thankYouGoToDashboard') || 'Go to Dashboard'}
        </button>
      </div>
    </>
  );
};

export default ThankYouPage; 